<template>
  <div class="relative">
    <label v-if="label != ''" :for="name" class="flex ai-c jc-sb">
      {{label}}
      <router-link v-if="extraLink != ''" :to="extraLink" class="text-primary">
        Clique aqui se você esqueceu sua senha!
      </router-link>
    </label>
    <div :class="[
      prefix !== '' && 'relative with-prefix',
      showPasswordToggle && type === 'password' && 'with-password-toggle',
      'input-cont-hint'
    ]">
      <input
        v-if="mask.length > 0"
        :class="error.message != '' ? `${className} has-error` : `${className}`"
        :id="name"
        :type="inputType"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        v-mask="mask"
        :disabled="disabled"
        :style="addStyle"
        :autocomplete="autocomplete"
      >

      <input
        v-else-if="money"
        :class="error.message != '' ? `${className} has-error` : `${className}`"
        :id="name"
        :type="inputType"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        v-money="moneyFormat"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        :disabled="disabled"
        :style="addStyle"
        :autocomplete="autocomplete"
      >

      <input
        v-else
        :class="error.message != '' ? `${className} has-error` : `${className}`"
        :id="name"
        :type="inputType"
        :name="name"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup="$emit('inputChanged', $event.target.value)"
        :disabled="disabled"
        :style="addStyle"
        :autocomplete="autocomplete"
      >

      <button
        v-if="showPasswordToggle && type === 'password'"
        type="button"
        class="password-toggle"
        :aria-label="passwordVisible ? 'Ocultar senha' : 'Mostrar senha'"
        @click="passwordVisible = !passwordVisible"
      >
        <svg
          v-if="passwordVisible"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-eye-off"
        >
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-eye"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </button>

      <div v-if="prefix !== ''" class="prefix">
        {{ prefix }}
      </div>
    </div>

    <div v-if="error.message != ''" class="field-error mt-1">
      {{error.message}}
    </div>

    <div class="input-hint" v-if="hint">
      <p class="text-medium text-white">{{ hintMessage }}</p>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { VMoney } from 'v-money';

export default {
  name: 'Input',
  directives: {
    mask,
    money: VMoney,
  },
  data() {
    return {
      moneyFormat: {
        decimal: ',',
        thousands: '.',
      },
      passwordVisible: false,
    };
  },
  computed: {
    inputType() {
      if (this.showPasswordToggle && this.type === 'password') {
        return this.passwordVisible ? 'text' : 'password';
      }

      return this.type;
    },
  },
  watch: {
    value(newVal) {
      if (this.showPasswordToggle && !newVal) {
        this.passwordVisible = false;
      }
    },
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Error,
      default: () => new Error(''),
    },
    value: {},
    extraLink: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: Array,
      default: () => [],
    },
    money: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    addStyle: {
      type: String,
      default: '',
    },
    hint: {
      type: Boolean,
      default: false,
    },
    hintMessage: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    showPasswordToggle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .with-prefix input {
    padding-left: 40px;
  }

  .with-password-toggle {
    position: relative;
  }

  .with-password-toggle input {
    padding-right: 3rem;
  }

  .password-toggle {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--primary-color);
    cursor: pointer;
  }

  .prefix {
    position: absolute;
    width: 40px;
    top: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-hint {
    position: absolute;
    bottom: calc(100% + 15px);
    background-color: var(--primary-color);
    padding: 0.75rem;
    border-radius: var(--medium-border-radius);
    text-align: left;
    opacity: 0;
    visibility: hidden;
    transition: var(--all-transition);
  }

  .input-hint::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0px 10px;
    border-color: var(--primary-color) transparent transparent transparent;
    position: absolute;
    top: 100%;
  }

  .input-cont-hint:hover ~ .input-hint {
    opacity: 1;
    visibility: visible;
  }
</style>
